import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-ag-download-cell-renderer',
  templateUrl: './ag-download-cell-renderer.component.html',
  styleUrls: ['./ag-download-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AgDownloadCellRendererComponent {
  params: any;
  outputType: any;

  agInit(params: any) {
    this.params = params;
    this.outputType = params.data.output_type;
  }

  refresh(params: any) {
    this.params = params;
    this.outputType = params.data.output_type;
  }
}
